var poll = function(callback, interval, timeout) {
    return new Promise(function(resolve, reject) {
        var pollInterval;
        var finished = false;
        var elapsedTime = 0;
        var done = function(value) {
            finished = true;
            clearInterval(pollInterval);
            resolve(value);
        };
        var error = function(err) {
            finished = true;
            clearInterval(pollInterval);
            reject(err);
        };
        callback(done, error);
        if (!finished) {
            pollInterval = setInterval(function() {
                elapsedTime += interval;
                try {
                    callback(done, error);
                    if (finished === false && elapsedTime >= timeout) {
                        error(new Error("Poll timed out"));
                    }
                } catch (err) {
                    error(err);
                }
            }, interval);
        }
    });
};
export default poll;

//# sourceMappingURL=poll.js.map